import React, { useState } from "react";
import { Link } from "react-router-dom";
import aboutspinoffmain from "../img/about/about-spinoff-main.jpg";
import spinofftechnoparkabout from "../img/about/spinoff-technopark-about.jpg";
import numberbackground from "../img/about/number-background.jpg";
import bg5 from "../images/background/bg-5.png";
import crossline2 from "../images/background/cross-line2.png";
import ledlights from "../img/about/led-lights.jpg";
import lithiumbattery from "../img/about/lithium-battery.jpg";
import upsinverter from "../img/about/ups-inverter.jpg";
import sheetmetal from "../img/about/sheet-metal.jpg";
import retailunitsfancy from "../img/about/retail-units-fancy.jpg";
import bgmap from "../images/background/bg-map.png";
import contactus from "../img/about/contact-us.jpg";
import "../css/style.css";
import "../css/bootstrap.min.css";
import "../css/bootstrap-slider.min.css";
import "../css/bootstrap-select.min.css";

import "../css/flaticon.min.css";
import "../css/footer.css";
import "../css/home.css";

import "../css/loader.min.css";
import "../css/magnific-popup.min.css";

import "../css/owl.carousel.min.css";

import "../css/fontawesome/css/font-awesome.min.css";
import "../css/fontawesome/fonts/fontawesome-webfont.svg";
import "../css/fontawesome/fonts/fontawesome-webfont.eot";
import "../css/fontawesome/fonts/fontawesome-webfont.ttf";
import "../css/fontawesome/fonts/fontawesome-webfont.woff";
import "../css/fontawesome/fonts/fontawesome-webfont.woff2";
import "../css/fontawesome/fonts/FontAwesome.otf";
import "../css/fontawesome/less/animated.less";
import "../css/fontawesome/less/bordered-pulled.less";
import "../css/fontawesome/less/core.less";
import "../css/fontawesome/less/fixed-width.less";
import "../css/fontawesome/less/font-awesome.less";
import "../css/fontawesome/less/icons.less";
import "../css/fontawesome/less/larger.less";
import "../css/fontawesome/less/list.less";
import "../css/fontawesome/less/mixins.less";
import "../css/fontawesome/less/path.less";
import "../css/fontawesome/less/rotated-flipped.less";
import "../css/fontawesome/less/screen-reader.less";
import "../css/fontawesome/less/stacked.less";
import "../css/fontawesome/less/animated.less";
import "../css/skin/skin-1.css";
import "../css/skin/skin-2.css";
import "../css/skin/skin-3.css";
import "../css/skin/skin-4.css";
import "../css/skin/skin-5.css";
import "../css/skin/skin-6.css";
import "../css/skin/skin-7.css";
import "../css/skin/skin-8.css";
import "../css/skin/skin-9.css";
import "../css/skin/skin-10.css";
import "../fonts/Flaticon.eot";
import "../fonts/Flaticon.ttf";
import "../fonts/Flaticon.woff";
import "../fonts/Flaticon.woff2";
import "../fonts/glyphicons-halflings-regular.svg";
import "../fonts/glyphicons-halflings-regular.eot";
import "../fonts/glyphicons-halflings-regular.ttf";
import "../fonts/glyphicons-halflings-regular.woff";
import "../fonts/glyphicons-halflings-regular.woff2";
import "../js/aboutslider.js";
import mohalivideo  from "../video/mohaliintro.mp4";

const About = () => {
  const [currentIndex, setCurrentIndex] = useState(0); // Track the current index of the carousel

  const data = [
    {
      image: ledlights,
      title: "Led Lights",
      link: "/our-services/led-lights",
      description: "Led Lights Manufacturing",
    },
    {
      image: lithiumbattery,
      title: "Lithium Batteries",
      link: "/our-services/lithium-battery",
      description: "Lithium Battery Manufacturing",
    },
    {
      image: upsinverter,
      title: "Inverter & UPS",
      link: "/our-services/inverter-ups",
      description: "Inverter & UPS Manufacturing",
    },
    {
      image: sheetmetal,
      title: "Sheet Metal",
      link: "/our-services/sheet-metal",
      description: "Stainless Steel Metal",
    },
   /* {
      image: retailunitsfancy,
      title: "Fancy Store",
      link: "#",
      description: "Fancy Lights Store",
    },
    {
      image: ledlights,
      title: "Led Lights",
      link: "/our-services/led-lights",
      description: "Led Lights Manufacturing",
    },
    {
      image: lithiumbattery,
      title: "Lithium Batteries",
      link: "/our-services/lithium-battery",
      description: "Lithium Battery Manufacturing",
    },
    {
      image: upsinverter,
      title: "Inverter & UPS",
      link: "/our-services/inverter-ups",
      description: "Inverter & UPS Manufacturing",
    },
    {
      image: sheetmetal,
      title: "Sheet Metal",
      link: "/our-services/sheet-metal",
      description: "Stainless Steel Metal",
    },
    {
      image: retailunitsfancy,
      title: "Fancy Store",
      link: "#",
      description: "Fancy Lights Store",
    },*/
  ];

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : data.length - 1
    ); // Move to the previous item (wraps around)
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex <  1 ? prevIndex + 1 : 0
    ); // Move to the next item (wraps around)
  };

  const [openSection, setOpenSection] = useState(null); // Track which section is open

  // Function to handle the toggle
  const toggleSection = (index) => {
    if (openSection === index) {
      setOpenSection(null); // Close the section if it's already open
    } else {
      setOpenSection(index); // Open the clicked section
    }
  };

  const timelineData = [
    {
      year: "2013",
      title: "START UP as incubation for LED lights",
      description:
        "As Indian LED industry was just getting evolved from CFL to LED, and no major manufacturing was visible in India, Spinoff took an initiative to get in manufacturing by starting with R&amp;D driven approach for NPD in LED lights , by doing product development in LED bulb and LED tube lights with power electronic and thermal treatment of aluminum and plastic with start up space in less then 200 sq ft area for in Mohali near Chandigarh.",
    },
    {
      year: "2014/2015",
      title: "Production- Phase-1- 12 SKU",
      description:
        "After successful trial of NPD Spinoff started manufacturing LED bulb, Tube lights and few other SKU total about 12 SKU in LED lights in different Sizes and shapes with best of quality and production facility in 20000 sq ft space partially occupied reserve for future.",
    },
    {
      year: "2016/2017",
      title: "Production- Phase-2- 40 SKU",
      description:
        "After successful commissioning of Phase-1 Spinoff started manufacturing COB lights down lighter and took total SKU from 12-40 in Design/Style application/in Home segment of LED lights with in-house production supported by in-house R&amp;D- with best of quality and production facility",
    },
    {
      year: "2018/2019",
      title: "Production- Phase-3- 100 SKU",
      description:
        "After successful commissioning of Phase-1 and 2, the more and more people are aware and LED was every one choice now, and price also have corrected to make it affordable and industry opened very widely and huge product range started coming from china – which gave us more chance of new product variant and now we have scaled up to 80SKU from 40-100 in Design/Style application/in Home and commercial segment of LED lights with in-house production supported by in-house R&amp;D- with best of quality and production facility",
    },
    {
      year: "2020",
      title: "Production- Phase-4- 200 SKU",
      description:
        "After successful commissioning of Phase-1/2/3, the more and more reach of us in residential housing/commercial building/architects and this phase we started working on solar lights in street lights and also industrial lighting for PHARMACEUTICAL and also in INSTITUTIONAL LED - people are aware and LED was every one choice now, and price also have corrected to make it affordable and industry opened very widely and huge product range started coming from china – which gave us more chance of new product variant and now we have scaled up to 200SKU from 100-100 in Design/Style application/in Home/commercial/industrial/institutional/Hospitality segment of LED lights with in-house production supported by in-house R&amp;D- with best of quality and production facility",
    },
    {
      year: "2021",
      title:
        "Phase-5- 400 SKU Plus New Mega factory with 250000 sq feet plot area",
      description:
        "This year too in addition to increase in SKU to more then 400 decision to start a new factory in RAJPURA for CNC laser cut and CNC bending machines in sheet metal body making for lights and its drivers",
    },
    {
      year: "2022",
      title:
        "Phase-6- 600 SKU Plus New Factory for sheet metal works at RAJPURA",
      description:
        "This year full commissioning and production activity took the base to more then 600SKU and completely establishing the production line for new plant of sheet metal enclosures.",
    },
    {
      year: "2023",
      title:
        "Phase-7- 700 SKU Plus New Factory SETUP for LITHIUM Battery packs for EV",
      description:
        "This year full commissioning and production activity took the base to 700SKU and completely establishing the production line for new plant of Lithium battery packs with state of art facility and R&amp;D driven production /Testing/QC house, this year we have been engaged in establishing the new factory set up in the new segment.",
    },
    {
      year: "2024",
      title:
        "Phase-8- 700 SKU Plus New Factory SETUP for LITHIUM Battery packs for EV+ESS+UPS+INVERTER+OTHER application",
      description:
        "This year full focus on NPD of new packs by reverse engineering for many different models of battery packs used in 2W/3W/UPS/INVERTER/ESS etc",
    },
    {
      year: "FUTURISTIC JOURNEY AHEAD",
      title:
        "Production of Battery packs for EV+ESS+UPS+INVERTER+OTHER application...",
      description:
        "We intend to make our presence in various power electronic segment connected with Green energy storage system in various application across different segment of universe- Aeronautical, DRONE, Railways ESS solutions, Portable ESS etc, with own set up in R&amp;D , Design house, and own manufacturing set up in Tool room and molding going forward in addition to lithium Energy application based on Engineering.",
    },
  ];

  return (
    <div className="page-content">
      {/* INNER PAGE BANNER */}
      <div
        className="sx-bnr-inr overlay-wraper bg-parallax bg-top-center"
        data-stellar-background-ratio="0.5"
        style={{ backgroundImage: `url(${aboutspinoffmain})` }}
      >
        <div className="overlay-main bg-black opacity-07" />
        <div className="container">
          <div className="sx-bnr-inr-entry">
            <div className="banner-title-outer">
              <div className="banner-title-name">
                <h2 className="m-tb0">About Us</h2>
               {/* <p>
                  The essence of interior design will always be about people and
                  how they live. It is about the realities of what makes for an
                  attractive, civilized.
                </p>*/}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* INNER PAGE BANNER END */}
      {/* ABOUT COMPANY START */}
      <div className="section-full mobile-page-padding p-t80 p-b50 bg-gray">
        <div className="container">
          <div className="section-content">
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-12">
                <div className="about-home-3 m-b30 bg-white">
                  <h3 className="m-t0 m-b20 sx-tilte">About Spinoff</h3>
                  <p>
                    SPINOFF Technopark Ltd, headquartered in Chandigarh, is
                    a leader in SMART LED lighting, SMPS, and lithium energy
                    solutions, backed by over 35 years of industry experience
                    and advanced manufacturing capabilities.
                  </p>
                  {/*<ul className="list-angle-right anchor-line">
                    <li>
                      <Link to="/our-services/lithium-battery">
                        Lithium Battery Manufacturing Units
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-services/led-lights">
                        Led Lighting Manufacturing Units
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-services/inverter-ups">
                        Inverter &amp; UPS Manufacturing Units
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-services/sheet-metal">
                        Sheet Metal Manufacturing Units
                      </Link>
                    </li>
                  </ul>*/}
                  <ul className="list-angle-right anchor-line">
                  <li>
                      <Link to="/our-services/led-lights">
                        LED Lighting Manufacturing Units
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-services/lithium-battery">
                        Lithium Battery Manufacturing Units
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-services/inverter-ups">
                        Inverter &amp; UPS Manufacturing Units
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-services/sheet-metal">
                        Sheet Metal Manufacturing Units
                      </Link>
                    </li>
                  </ul>
                  {/*<div className="text-left">
            
                      <Link to="/our-infrastructure" className="site-button btn-half">
                      <span>Our Infrastructure</span>
                      </Link>
                    
    
                  </div>*/}
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12">
                <div className="video-section-full-v2">
                  <div
                    className="video-section-full bg-no-repeat bg-cover bg-center overlay-wraper m-b30"
                    style={{
                      backgroundImage: `url(${spinofftechnoparkabout})`,
                    }}
                  >
                    <div className="overlay-main bg-black opacity-04" />
                    <div className="video-section-inner">
                      <div className="video-section-content">
                        <a
                          href={mohalivideo}
                          className="mfp-video play-now"
                        >
                          <i className="icon fa fa-play" />
                          <span className="ripple" />
                        </a>
                        <div className="video-section-bottom">
                          <h3 className="sx-title text-white">
                            Our Journey So Far
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ABOUT COMPANY END */}
      {/* COUNTER START */}
      <div
        className="section-full overlay-wraper sx-bg-secondry mobile-page-padding  p-t80 p-b50 bg-parallax ml-auto"
        data-stellar-background-ratio="0.5"
        style={{ backgroundImage: `url(${numberbackground})` }}
      >
        <div className="overlay-main bg-black opacity-05" />
        <div className="container">
          <div className="section-content">
            <div className="counter-blocks">
              <div className="row">
                <div className="col-xl-3 col-md-6 m-b30 ">
                  <div
                    className="sx-count text-white sx-icon-box-wraper bg-repeat p-a30"
                    style={{ backgroundImage: `url(${bg5})` }}
                  >
                    <h2 className="m-t0 sx-text-primary text-right">
                      <span className="counter">16</span>
                      <span>+</span>
                    </h2>
                    <h4 className="m-b0">Years Experience</h4>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6 m-b30">
                  <div
                    className="sx-count  text-white sx-icon-box-wraper bg-repeat p-a30"
                    style={{ backgroundImage: `url(${bg5})` }}
                  >
                    <h2 className="m-t0  sx-text-primary text-right">
                      <span className="counter">200</span>
                      <span>+</span>
                    </h2>
                    <h4 className="m-b0">Project Taken</h4>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6 m-b30">
                  <div
                    className="sx-count  text-white sx-icon-box-wraper bg-repeat p-a30"
                    style={{ backgroundImage: `url(${bg5})` }}
                  >
                    <h2 className="m-t0  sx-text-primary text-right">
                      <span className="counter">10</span>
                      <span>+</span>
                    </h2>
                    <h4 className="m-b0">Awards Won</h4>
                  </div>
                </div>
               {/* <div className="col-xl-3 col-md-6 m-b30">
                  <div
                    className="sx-count  text-white sx-icon-box-wraper bg-repeat  p-a30"
                    style={{ backgroundImage: `url(${bg5})` }}
                  >
                    <h2 className="m-t0  sx-text-primary text-right">
                      <span className="counter">15</span>
                    </h2>
                    <h4 className="m-b0">
                      Manufacturing in Electronic Vertical
                    </h4>
                  </div>
                </div>*/}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* COUNTER  END */}
      {/* MISSION AND VISION START */}
      {/* OUR SERVICES START */}
      <div className="section-full mobile-page-padding p-t80  p-b50 bg-gray">
        <div className="section-content">
          <div className="container">
            {/* TITLE START */}
            <div className="section-head">
              <div className="sx-separator-outer separator-left">
                <div
                  className="sx-separator bg-white bg-moving bg-repeat-x"
                  style={{ backgroundImage: `url(${crossline2})` }}
                >
                  <h3 className="sep-line-one ">Our Mission &amp; Vision</h3>
                </div>
              </div>
            </div>
            {/* TITLE END */}
            <div className="row">
              {/* Block one */}
              <div className="col-lg-4 col-md-6 col-sm-12 m-b30">
                <div className="sx-icon-box-wraper  icon-count-2-outer">
                  <div className="icon-count-2 bg-white">
                    {/*<span className="icon-count-number">01</span>*/}
                   {/* <div className="icon-xl inline-icon m-b5 scale-in-center">
                      <span className="icon-cell">
                        <i className="fa fa-group" />
                      </span>
                    </div>*/}
                    <div className="icon-content">
                      <h4 className="sx-tilte">Mission</h4>
                      <p>
                        Our mission is to reinforce our belief that" our future is customers' happiness" by 
                        creating energy efficient products in LED lights and Lithium Battery segment.
                      </p>
                      <div className="text-left">
                        {/* <a href="#" class="site-button-link">Read More</a> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Block Two */}
              <div className="col-lg-4 col-md-6 col-sm-12 m-b30">
                <div className="sx-icon-box-wraper icon-count-2-outer">
                  <div className="icon-count-2 bg-white">
                    {/*<span className="icon-count-number">02</span>*/}
                    {/*<div className="icon-xl inline-icon m-b5 scale-in-center">
                      <span className="icon-cell">
                        <i className="fa fa-eye" />
                      </span>
                    </div>*/}
                    <div className="icon-content">
                      <h4 className="sx-tilte">Vision</h4>
                      <p>
                        To become a world leader in  creating energy-efficient products which  positively imapct the environment.
                      </p>
                      <div className="text-left">
                        {/* <a href="#" class="site-button-link">Read More</a> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Block Three */}
              <div className="col-lg-4 col-md-6 col-sm-12 m-b30">
                <div className="sx-icon-box-wraper icon-count-2-outer">
                  <div className="icon-count-2 bg-white">
                    {/*<span className="icon-count-number">03</span>*/}
                    {/*<div className="icon-xl inline-icon m-b5 scale-in-center">
                      <span className="icon-cell">
                        <i className="fa fa-heart" />
                      </span>
                    </div>*/}
                    <div className="icon-content">
                      <h4 className="sx-tilte">Values</h4>
                      <p>
                        Innovation, sustainability and excellence drive our
                        commitment to quality and customer satisfaction.
                      </p>
                      <div className="text-left">
                        {/* <a href="#" class="site-button-link">Read More</a> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* OUR SERVICES  END */}
      {/* MISSION AND VISION END */}
      {/* PROJECTS START */}
      <div className="section-full mobile-page-padding  p-t80 p-b50 bg-white">
        <div className="section-content">
          <div className="container">
            {/* TITLE START */}
            <div className="section-head">
              <div className="sx-separator-outer separator-center">
                <div
                  className="sx-separator bg-white bg-moving bg-repeat-x"
                  style={{ backgroundImage: `url(${crossline2})` }}
                >
                  <h3 className="sep-line-one">Our Business Verticals</h3>
                </div>
              </div>
            </div>
            {/* TITLE END */}
          </div>
          <div className="filter-carousal-1-outer relative z-index1">
            <div className="container">
              {/* TITLE START */}
             {/* <div className="text-center clearfix filter-pos-right shadow m-b30">
                <ul className="btn-filter-wrap">
                  <li className="btn-filter btn-active" data-filter="*">
                    All
                  </li>
                  <li className="btn-filter" data-filter=".col-one">
                    Manufacturing Units
                  </li>
                </ul>
              </div>*/}
            </div>
            {/* TITLE END */}
            <div className="filter-carousal-1 container-fluid1 p-b30">
              {/* IMAGE CAROUSEL START */}
              <div className="section-content">
                <div className="carousel-container">
                  <div
                    className="carousel"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      transform: `translateX(-${currentIndex * 20}%)`,
                      transition: "transform 0.5s ease-in-out",
                    }}
                  >
                    {/* Render 5 separate divs */}
                    {data.map((item, index) => (
                      <div
                        key={index}
                        className="item"
                        style={{
                          width: "calc(27% - 10px)", // Adjust the width to account for the gap (subtracting 10px for margin)
                          marginRight: "10px", // Add gap between images
                        }}
                      >
                        <div className="sx-box image-hover-block">
                          <div className="sx-thum-bx">
                            <img src={item.image} alt={item.title} />
                          </div>
                          <div className="sx-info p-t20 text-white">
                            <h4 className="sx-tilte">
                              <Link to={item.link}>{item.title}</Link>
                            </h4>
                            {/*<p className="m-b0">{item.description}</p>*/}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <br />
                <br />
                {/* Carousel Navigation Below */}
                <div className="carousel-nav">
                  <div className="owl-prev" onClick={handlePrevious}>
                    Prev
                  </div>
                  <div className="owl-next" onClick={handleNext}>
                    Next
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* PROJECTS  END */}
      {/* OUR AWARDS SECTION START */}
      {/*<div
        className="section-full p-t80 p-b50 sx-bg-secondry bg-no-repeat bg-bottom-center mobile-page-padding"
        style={{ backgroundImage: `url(${bgmap})` }}
      >
        <div className="container">
          {/* TITLE START 
          <div className="section-head">
            <div className="sx-separator-outer separator-center">
              <div
                className="sx-separator bg-white bg-moving bg-repeat-x"
                style={{ backgroundImage: `url(${crossline2})` }}
              >
                <h3 className="sep-line-one">Our Journey</h3>
              </div>
            </div>
          </div>
          {/* TITLE END 
          <div className="section-content">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12 m-b30">
                {timelineData.map((item, index) => (
                  <div key={index} className="sx-box our-story text-white">
                    <div
                      className="mt-media our-story-info d-flex justify-content-start"
                      onClick={() => toggleSection(index)} // Toggle on click
                      style={{ cursor: "pointer" }} // Make it clear it's clickable
                    >
                      <div className="our-story-time">
                        <span className="date">{index + 1}</span>
                        <span className="month">S</span>
                      </div>
                      <h4 className="text-uppercase our-story-year">
                        {item.year}:-{item.title}
                      </h4>
                    </div>
                    {openSection === index && ( // Show content only if section is open
                      <div className="our-story-detail">
                        <p>{item.description}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
              {/* <div class="col-xl-6 col-lg-6 col-md-12">
                          <div class="sx-box our-story text-white">
                              <div class="mt-media our-story-info d-flex justify-content-start">
                                  <div class="our-story-time"><span class="date">05</span><span class="month">S</span></div>
                                  <h4 class="text-uppercase our-story-year">2017-18</h4>
                              </div>
                              <div class="our-story-detail">
                                  <h4>Portfolio Enhanced</h4>
                                  <p>Portfolio enhanced by 1000 products on board with another two brands approvals by ministry of northern railway & coach lights for Shatabdi for Indian Railways</p>
                              </div>
                          </div>
                          <div class="sx-box our-story text-white">
                              <div class="mt-media our-story-info d-flex justify-content-start">
                                  <div class="our-story-time"><span class="date">06</span><span class="month">S</span></div>
                                  <h4 class="text-uppercase our-story-year">2019-20</h4>
                              </div>
                              <div class="our-story-detail">
                                  <h4>SKU's</h4>
                                  <p>Portfolio enhanced by 2500+ SKU's onboard with “Flame Proof Light” approved by CIMFR Dhanbad.</p>
                              </div>
                          </div>
                          <div class="sx-box our-story text-white">
                              <div class="mt-media our-story-info d-flex justify-content-start">
                                  <div class="our-story-time"><span class="date">07</span><span class="month">S</span></div>
                                  <h4 class="text-uppercase our-story-year">2021-22</h4>
                              </div>
                              <div class="our-story-detail">
                                  <h4>Opening Showrooms</h4>
                                  <p>Opening of two new showroom for "Finike Light" & set up Manufacturing Plant for <strong> Modular Kitchen & Metalcraft</strong></p>
                              </div>
                          </div>
                          <div class="sx-box our-story text-white">
                              <div class="mt-media our-story-info d-flex justify-content-start">
                                  <div class="our-story-time"><span class="date">08</span><span class="month">S</span></div>
                                  <h4 class="text-uppercase our-story-year">2022-23</h4>
                              </div>
                              <div class="our-story-detail">
                                  <h4>Lithium Assembly</h4>
                                  <p>Set up a Greenfield Manufacturing Facility at Rajpura covering an area of 250000 Sq. Ft. for Lithium Battery Pack Assembly with the brand name of "Finike Lithium". </p>
                              </div>
                          </div>
                       </div>                                                                                                                             
            </div>
          </div>
        </div>
      </div>*/}
      {/* OUR AWARDS SECTION END */}
      {/* CONTACT FORM START */}
      {/* <div
    className="section-full p-tb80 mobile-page-padding bg-center bg-no-repeat bg-fixed"
    style={{ backgroundImage: `url(${contactus})` }}
  >
    <div className="section-content">
      <div className="container get-in-touch-form">
        {/* TITLE START 
        <div className="section-head">
          <div className="sx-separator-outer separator-left">
            <div
              className="sx-separator bg-white bg-moving bg-repeat-x"
              style={{ backgroundImage: `url(${crossline2})` }}
            >
              <h3 className="sep-line-one">Contact Us</h3>
            </div>
          </div>
        </div>
        {/* TITLE END 
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12">
            <div
              className="contact-home1-left contact-home1-left-v2 shadow-lg bg-white p-a30"
              style={{ backgroundImage: `url(${bgmap})` }}
            >
              <form
                className="cons-contact-form2 form-transparent"
                method="post"
                action="form-handler2.php"
              >
                <div className="input input-animate">
                  <label htmlFor="name">Name</label>
                  <input type="text" name="username" id="name" required="" />
                  <span className="spin" />
                </div>
                <div className="input input-animate">
                  <label htmlFor="email">Email</label>
                  <input type="email" name="email" id="email" required="" />
                  <span className="spin" />
                </div>
                <div className="input input-animate">
                  <label htmlFor="Phone">Phone</label>
                  <input type="text" name="phone" id="Phone" required="" />
                  <span className="spin" />
                </div>
                <div className="input input-animate">
                  <label htmlFor="message">Textarea</label>
                  <textarea
                    name="message"
                    id="message"
                    required=""
                    defaultValue={""}
                  />
                  <span className="spin" />
                </div>
                <div className="text-left p-t10">
                  <button
                    type="submit"
                    className="site-button-secondry btn-half "
                  >
                    <span> Submit Now</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> */}
      {/* CONTACT FORM  END */}
    </div>
  );
};

export default About;
